import React, { Context } from 'react'
import { css } from '@emotion/css'
import { TabContextProps } from './tab-context'

export interface TabContentConfig<TTabs extends string> {
  readonly id: TTabs
  readonly content: any
}

/**
 * Manages rendering the actual content sections for each tab.
 * Depends on TabManager to provide context.
 */
export function TabContentSections<TTabs extends string>({
  tabContentConfigs,
  context: TabContext
}: {
  readonly tabContentConfigs: Array<TabContentConfig<TTabs>>
  readonly context: Context<TabContextProps<TTabs>>
}) {
  return (
    <TabContext.Consumer>
      {({ currentTabID }) => {
        return tabContentConfigs.map(
          ({ id, content: TabContent }, configIndex) => {
            const isActive = currentTabID === id
            return (
              <div
                id="tab-content-container"
                key={configIndex}
                className={css`
                  display: ${isActive ? 'block' : 'none'};
                  padding: 20px 0 0 40px;
                `}
              >
                <TabContent tabID={id} isActive={isActive} />
              </div>
            )
          }
        )
      }}
    </TabContext.Consumer>
  )
}
